/*
 *
 * SurveyProceed constants
 *
 */

export const SURVEY_PROCEED = 'app/CheckoutPage/SURVEY_PROCEED';
export const SURVEY_PROCEED_SUCCESS = 'app/CheckoutPage/SURVEY_PROCEED_SUCCESS';
export const SURVEY_PROCEED_ERROR = 'app/CheckoutPage/SURVEY_PROCEED_ERROR';
export const SURVEY_PROCEED_CRITICAL_ERROR =
  'app/CheckoutPage/SURVEY_PROCEED_CRITICAL_ERROR';

export const SURVEY_STATUS = 'app/CheckoutPage/SURVEY_STATUS';
export const SURVEY_STATUS_SUCCESS = 'app/CheckoutPage/SURVEY_STATUS_SUCCESS';
export const SURVEY_STATUS_ERROR = 'app/CheckoutPage/SURVEY_STATUS_ERROR';

export const SURVEY_ERROR_CODES = {
  SURVEY_PPS_MODIFIED: 'SURVEY_PPS_MODIFIED',
};

export const SURVEY_PROCEED_ERROR_CODES = {
  EMPTY_ACCOUNT_CREDITS: 'EMPTY_ACCOUNT_CREDITS',
  INSUFFICIENT_ACCOUNT_CREDITS: 'INSUFFICIENT_ACCOUNT_CREDITS',
  STRIPE_INVALID_REQUEST: 'STRIPE_INVALID_REQUEST',
  STRIPE_AUTHENTICATION_ERROR: 'STRIPE_AUTHENTICATION_ERROR',
  STRIPE_CONNECTION_ERROR: 'STRIPE_CONNECTION_ERROR',
  STRIPE_GENERAL_ERROR: 'STRIPE_GENERAL_ERROR',
  EXPIRED_CARD: 'EXPIRED_CARD',
  CARD_GENERAL_ERROR: 'CARD_GENERAL_ERROR',
  INVOICE_LIMIT_REACHED: 'INVOICE_LIMIT_REACHED',
  INVOICE_LIMIT_NOT_ENOUGH: 'INVOICE_LIMIT_NOT_ENOUGH',
  SURVEY_PPS_MODIFIED: 'SURVEY_PPS_MODIFIED',
  BLOCKED_USER_BY_BUDGET: 'BLOCKED_USER_BY_BUDGET',
  BLOCKED_ACCOUNT_BY_BUDGET: 'BLOCKED_ACCOUNT_BY_BUDGET',
  ERROR_CHECKOUT_QUESTIONNAIRE: 'ERROR_CHECKOUT_QUESTIONNAIRE',
  ERROR_CHECKOUT_MISSING_NON_SCREENING_QUESTIONS:
    'ERROR_CHECKOUT_MISSING_NON_SCREENING_QUESTIONS',
  ERROR_CHECKOUT_LOOP_AND_MERGE: 'ERROR_CHECKOUT_LOOP_AND_MERGE',
  ERROR_CHECKOUT_AB: 'ERROR_CHECKOUT_AB',
  ERROR_CHECKOUT_TARGETING: 'ERROR_CHECKOUT_TARGETING',
  ERROR_CHECKOUT_SURVEY_COMPLETES: 'ERROR_CHECKOUT_SURVEY_COMPLETES',
  ERROR_CHECKOUT_MISSING_PERKS: 'ERROR_CHECKOUT_MISSING_PERKS',
  ERROR_CHECKOUT_SURVEY_CONFIGURATION: 'ERROR_CHECKOUT_SURVEY_CONFIGURATION',
  ERROR_CHECKOUT_PEEQ_TARGETING: 'ERROR_CHECKOUT_PEEQ_TARGETING',
  ERROR_CHECKOUT_PEEQ_PROJECT_VALIDATION:
    'ERROR_CHECKOUT_PEEQ_PROJECT_VALIDATION',
  GENERIC_ERROR_CHECKOUT_PEEQ_PROJECT_VALIDATION:
    'GENERIC_ERROR_CHECKOUT_PEEQ_PROJECT_VALIDATION',
  ERROR_CHECKOUT_REALTIME_PRICING: 'ERROR_CHECKOUT_REALTIME_PRICING',
  ERROR_CHECKOUT_SCREENING_QUESTIONS_SIZE:
    'ERROR_CHECKOUT_SCREENING_QUESTIONS_SIZE',
  ERROR_CHECKOUT_NON_SCREENING_QUESTIONS:
    'ERROR_CHECKOUT_NON_SCREENING_QUESTIONS',
  ERROR_CHECKOUT_SCREENING_QUESTIONNAIRE:
    'ERROR_CHECKOUT_SCREENING_QUESTIONNAIRE',
  ERROR_CHECKOUT_QUESTIONNAIRE_QUOTA_POSITION:
    'ERROR_CHECKOUT_QUESTIONNAIRE_QUOTA_POSITION',
  ERROR_CHECKOUT_HIDDEN_VARIABLES: 'ERROR_CHECKOUT_HIDDEN_VARIABLES',
  ERROR_CHECKOUT_SCREENING_LOGIC_INCONSISTENCY:
    'ERROR_CHECKOUT_SCREENING_LOGIC_INCONSISTENCY',
  ERROR_CHECKOUT_CONJOINT: 'ERROR_CHECKOUT_CONJOINT',
  ERROR_CHECKOUT_BIPOLAR: 'ERROR_CHECKOUT_BIPOLAR',
  BLOCKED_USER_BECAUSE_OF_NO_ACTIVE_BUDGET:
    'BLOCKED_USER_BECAUSE_OF_NO_ACTIVE_BUDGET',
  ERROR_CHECKOUT_DEPRECATED_LEGACY_SURVEY:
    'ERROR_CHECKOUT_DEPRECATED_LEGACY_SURVEY',
  ERROR_CHECKOUT_QUOTA_ASSIGNMENT_STRATEGY:
    'ERROR_CHECKOUT_QUOTA_ASSIGNMENT_STRATEGY',
  ERROR_CHECKOUT_QUOTA_LIMIT_TYPE: 'ERROR_CHECKOUT_QUOTA_LIMIT_TYPE',
};

export const SURVEY_PROCEED_QUESTIONNAIRE_ERROR_CODES = [
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_QUESTIONNAIRE,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_LOOP_AND_MERGE,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_AB,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_MISSING_NON_SCREENING_QUESTIONS,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_NON_SCREENING_QUESTIONS,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_MISSING_PERKS,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_CONJOINT,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_BIPOLAR,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_QUOTA_ASSIGNMENT_STRATEGY,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_QUOTA_LIMIT_TYPE,
];

export const SURVEY_PROCEED_TARGETING_ERROR_CODES = [
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_TARGETING,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_PEEQ_TARGETING,
  SURVEY_PROCEED_ERROR_CODES.ERROR_CHECKOUT_PEEQ_PROJECT_VALIDATION,
];

export const PAYMENT_TYPES = {
  CARD: 'card',
  INVOICE: 'invoice',
  CREDITS: 'credits',
  NO_METHOD: 'no_method',
};
